module.exports = __webpack_public_path__ + "img/emailNoti.32f6bcc1.svg";